import { withGlobal } from 'components/global/GlobalWrapper'
import { ResidentPaymentsAdmin } from './ResidentPaymentsAdmin'
import { residentPaymentsReducers } from 'components/stores/resident_payments/reducers'

export default withGlobal(ResidentPaymentsAdmin, { reducers: residentPaymentsReducers })
